<template>
    <div class="perangkat-list">
        <div v-for="(data, key) in dataList" :key="`card-perangkat-${key}`" class="m-d-12">
            <SOSlotCard
                :id="`card-${data.iddevice}`"
                :card-type="'shadow'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:before_head>
                    <div class="before-head-wrapper" style="margin-bottom: 10px;">
                        <DeviceStatus :data-status="getStatusMesin(data)" :data-mesin="data" />
                    </div>
                </template>
                <template v-slot:card_head>
                    <div class="d-flex-between-center" style="padding: 0px 2px;" @click="gotoDetail(data)">
                        <div>
                            <label class="m-d-0">+{{ data.country_code }}{{ data.number }}</label>
                        </div>
                        <div>
                            <svg
                                width="8"
                                height="12"
                                viewBox="0 0 8 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M0.91107 11.5892C0.585633 11.2638 0.585633 10.7362 0.91107 10.4107L5.32181 5.99998L0.911069 1.58923C0.585632 1.2638 0.585632 0.736159 0.911069 0.410723C1.23651 0.0852852 1.76414 0.0852851 2.08958 0.410723L7.08958 5.41072C7.41502 5.73616 7.41502 6.2638 7.08958 6.58923L2.08958 11.5892C1.76414 11.9147 1.23651 11.9147 0.91107 11.5892Z"
                                    fill="#C8D0DD"
                                />
                            </svg>
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div style="padding: 0px 2px;" @click="gotoDetail(data)">
                        <div class="nama-perangkat m-d-8">
                            <label class="m-d-0 f-c-black">{{ data.nama }}</label>
                        </div>
                        <div class="need-Confirm" v-if="getStatusMesin(data).kode === 2">
                            <label class="m-d-0">Harap selesaikan pembayaran</label>
                        </div>
                        <div v-else>
                            <div class="outlet">
                                <svg
                                    width="14"
                                    height="12"
                                    viewBox="0 0 14 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.3636 3.23409L11.9587 0.991401C11.8332 0.790078 11.6102 0.666687 11.3721 0.666687H2.62644C2.38831 0.666687 2.16534 0.790078 2.03979 0.991401L0.634856 3.23409C-0.090339 4.39224 0.552595 6.00282 1.90774 6.18683C2.00515 6.19982 2.10473 6.20631 2.20431 6.20631C2.84508 6.20631 3.41224 5.92489 3.8019 5.48977C4.19156 5.92489 4.76089 6.20631 5.39949 6.20631C6.04026 6.20631 6.60743 5.92489 6.99709 5.48977C7.38674 5.92489 7.95608 6.20631 8.59468 6.20631C9.23545 6.20631 9.80262 5.92489 10.1923 5.48977C10.5841 5.92489 11.1513 6.20631 11.7899 6.20631C11.8916 6.20631 11.989 6.19982 12.0864 6.18683C13.4459 6.00499 14.091 4.3944 13.3636 3.23409ZM11.7942 6.9012C11.5777 6.9012 11.3634 6.86873 11.1556 6.81894V8.97937H2.84291V6.81894C2.63509 6.86656 2.42078 6.9012 2.20431 6.9012C2.07442 6.9012 1.94237 6.89254 1.81465 6.87522C1.69342 6.8579 1.57436 6.82976 1.45963 6.79729V11.0575C1.45963 11.4407 1.76919 11.7503 2.15235 11.7503H11.8505C12.2336 11.7503 12.5432 11.4407 12.5432 11.0575V6.79729C12.4263 6.83193 12.3094 6.86007 12.1882 6.87522C12.0561 6.89254 11.9262 6.9012 11.7942 6.9012Z"
                                        fill="#C8D0DD"
                                    />
                                </svg>
                                <label class="m-d-0 m-l-8" v-if="data.outlet">{{ data.outlet }}</label>
                                <label class="m-d-0 m-l-8" v-else>Belum Terhubung</label>
                            </div>
                            <div class="quota">
                                <svg
                                    width="14"
                                    height="12"
                                    viewBox="0 0 14 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M0.333079 2.66669C0.333079 1.56212 1.22851 0.666687 2.33308 0.666687H11.6664C12.771 0.666687 13.6664 1.56212 13.6664 2.66669V3.32301C13.6665 3.3295 13.6665 3.33599 13.6664 3.34247V9.33335C13.6664 10.4379 12.771 11.3334 11.6664 11.3334H2.33308C1.22851 11.3334 0.333079 10.4379 0.333079 9.33335V3.34247C0.332984 3.33599 0.332984 3.3295 0.333079 3.32301V2.66669ZM1.66641 4.57903V9.33335C1.66641 9.70154 1.96489 10 2.33308 10H11.6664C12.0346 10 12.3331 9.70154 12.3331 9.33335V4.57903L8.10915 7.39499C7.43735 7.84285 6.56214 7.84285 5.89034 7.39499L1.66641 4.57903ZM12.3331 2.97656V2.66669C12.3331 2.2985 12.0346 2.00002 11.6664 2.00002H2.33308C1.96489 2.00002 1.66641 2.2985 1.66641 2.66669V2.97656L6.62995 6.28559C6.85388 6.43488 7.14561 6.43488 7.36955 6.28559L12.3331 2.97656Z"
                                        fill="#C8D0DD"
                                    />
                                </svg>
                                <label class="m-d-0 m-l-8">
                                    Sisa {{ data.quota }} pesan s.d. {{ $moment(data.next_due).format("Do MMM YYYY") }}
                                </label>
                            </div>
                            <div class="status-update" v-if="data.auto_renewal === 1">
                                <svg
                                    width="14"
                                    height="15"
                                    viewBox="0 0 14 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M1.16683 0.833334C1.62707 0.833334 2.00016 1.20643 2.00016 1.66667V6.77083C2.00016 7.32337 2.21966 7.85327 2.61036 8.24397C3.00106 8.63467 3.53096 8.85417 4.0835 8.85417H10.8217L8.59841 6.63092C8.27297 6.30549 8.27297 5.77785 8.59841 5.45241C8.92384 5.12697 9.45148 5.12697 9.77692 5.45241L13.4228 9.09824C13.7482 9.42368 13.7482 9.95132 13.4228 10.2768L9.77692 13.9226C9.45148 14.248 8.92384 14.248 8.59841 13.9226C8.27297 13.5972 8.27297 13.0695 8.59841 12.7441L10.8217 10.5208H4.0835C3.08893 10.5208 2.13511 10.1257 1.43185 9.42248C0.728584 8.71922 0.333496 7.7654 0.333496 6.77083V1.66667C0.333496 1.20643 0.706592 0.833334 1.16683 0.833334Z"
                                        fill="#6F7287"
                                    />
                                </svg>
                                <label class="m-d-0 m-l-8">Diperpanjang otomatis</label>
                            </div>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import DeviceStatus from "./DeviceStatus.vue";

import statusMesin from "../static/statusMesin";
import { moduleName } from "../store/state";

export default {
    name: "CardPerangkat",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
    },
    components: {
        SOSlotCard,
        DeviceStatus,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            pagination: "pagination",
            endItemofPage: "endItemofPage",
            totalPerangkat: "totalPerangkat",
        }),
        getStatusMesin() {
            return (data) => {
                return statusMesin.find((st) => st.kode === data.status);
            };
        },
        getLastId() {
            return this.endItemofPage.iddevice ? `card-${this.endItemofPage.iddevice}` : "";
        },
    },
    methods: {
        ...mapActions({
            getListPerangkat: `${moduleName}/getListPerangkat`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleDisplayItem: `${moduleName}/toggleDisplayItem`,
        }),
        async doLoadMore() {
            // if (this.totalPerangkat > this.pagination.length) {
            //     if (!this.isFetching) {
            //         await this.setLoadMore(true);
            //         await this.getListPerangkat();
            //     }
            // }
        },
        toggleCard(data) {
            this.toggleDisplayItem(data);
        },
        gotoDetail(data) {
            if (data.iddevice) {
                this.$router.push({ name: "wa_autosender.detail_perangkat", params: { id_device: data.iddevice } });
                this.smartTrackingClick("detail_perangkat_whatsapp");

            }
        },
    },
};
</script>
<style scoped>
.before-head-wrapper {
    margin-left: -18px;
    margin-right: -18px;
    margin-top: -10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
}
</style>
